import axios from '@/plugins/Axios'

function Requests() {
  async function register(formData) {
    try {
      const { data } = await axios.post('/register', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function registerWithLinkedin(formData) {
    try {
      const { data } = await axios.post('/linkedin-register', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function login(formData) {
    try {
      const { data } = await axios.post('/login', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function logout(token) {
    try {
      const { data } = await axios.post('/logout', token)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function forgotPassword(email) {
    try {
      const { data } = await axios.post('/forgot-password', email)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function resetPassword(id, token, formData) {
    try {
      const { data } = await axios.post(`/reset-password/${id}/${token}`, formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function changePassword(formData) {
    try {
      const { data } = await axios.post(`/change-password`, formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function loginWithLinkedIn() {
    try {
      const { data } = await axios.get('/social-login/linkedin/generate-url')
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function validateAuthToken() {
    try {
      const { data } = await axios.post(`/validate-token`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    register,
    registerWithLinkedin,
    login,
    logout,
    forgotPassword,
    resetPassword,
    loginWithLinkedIn,
    changePassword,
    validateAuthToken
  }
}

export default Requests()